import { useMemo } from 'react';
import {
  OrgAnalyticsContext,
  TeamAnalyticsDimensionType,
  useTeamAnalyticsIdQuery,
  OrgAnalyticsLabelValueFilterInput
} from 'graphql/types';
import { useSupervisorInsightContext } from '../SupervisorInsightContextProvider';

export const useGetTeamAnalyticsId = ({
  teamContext,
  teamDimensionType,
  labels,
  pageNumber,
  pageSize
}: {
  teamContext: OrgAnalyticsContext;
  teamDimensionType: TeamAnalyticsDimensionType;
  labels: OrgAnalyticsLabelValueFilterInput[];
  pageNumber: number;
  pageSize: number;
}): {
  data: string | undefined;
  loading: boolean;
} => {
  const { currentPeriod } = useSupervisorInsightContext();
  const { startDate, endDate } = currentPeriod ?? {};
  const { loading, data } = useTeamAnalyticsIdQuery({
    variables: {
      input: {
        context: teamContext,
        dimensionType: teamDimensionType,
        dateRange: {
          fromDate: startDate,
          toDate: endDate
        },
        filterBylabels: labels,
        pageNumber: pageNumber,
        pageSize: pageSize
      }
    }
  });
  return useMemo(
    () => ({
      data: data?.orgAnalytics?.teamAnalyticsExecute,
      loading
    }),
    [data, loading]
  );
};
